import { IAccountingUser } from '@/interfaces';
import { AccountingUserStatusEnum, AccountingUserTypeEnum, CurrencyEnum } from '@/enums';
import { amountToString } from '@/functions';
import { Briefcase, TrendingUp } from 'lucide-react';
import DataTableBodyCellOptions from './DataTableBodyCellOptions';
import { TEditParams } from '@/hooks/forms/useFormAccountingUser';
import { TCallbackForm } from '@/types';

interface TProps {
    user: IAccountingUser;
    onDelete: (_id: string) => Promise<void>;
    onEdit: (params: TEditParams) => void;
    onSeeDetails: (accountingUser: IAccountingUser, callback?: TCallbackForm<IAccountingUser>) => void;
}

const DataTableMobileItem = ({ user, onDelete, onEdit, onSeeDetails }: TProps) => {

    const isEmployee = user.type === AccountingUserTypeEnum.EMPLOYEE;
    const isActive = user.status === AccountingUserStatusEnum.ACTIVE;

    const renderIcon = () => {
        if (isEmployee) {
            return (
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100/50">
                    <Briefcase size={18} className="text-blue-600" />
                </div>
            );
        }
        return (
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-purple-100/50">
                <TrendingUp size={18} className="text-purple-600" />
            </div>
        );
    };

    return (
        <div className="flex items-center justify-between p-4 border rounded-lg bg-card hover:bg-muted/50 transition-colors shadow-xs cursor-pointer" onClick={() => onSeeDetails(user)}>
            <div className="flex items-center space-x-4">
                {renderIcon()}
                <div className="flex flex-col">
                    <span className="font-medium text-foreground">{user.name}</span>
                    <span className="text-sm text-muted-foreground">{user.role}</span>
                </div>
            </div>

            <div className="flex items-center space-x-4" onClick={(e) => e.stopPropagation()}>
                <div className="flex flex-col items-end">
                    <span className={`font-semibold ${isEmployee ? 'text-foreground' : 'text-blue-600'}`}>
                        {isEmployee
                            ? amountToString(user.baseSalaryEur || 0, CurrencyEnum.EUR)
                            : `${user.percentage}%`
                        }
                    </span>
                    <div className="flex items-center mt-1">
                        <div className={`h-1.5 w-1.5 rounded-full mr-1.5 ${isActive ? 'bg-green-500' : 'bg-gray-300'}`} />
                        <span className={`text-xs ${isActive ? 'text-foreground/80' : 'text-muted-foreground'}`}>
                            {isActive ? 'Actif' : 'Désactivé'}
                        </span>
                    </div>
                </div>
                <DataTableBodyCellOptions
                    accountingUser={user}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onSeeDetails={onSeeDetails} />
            </div>
        </div>
    );
};

export default DataTableMobileItem;
